         <div class="hero-header">
          <app-header-latest></app-header-latest>
      </div><!-- ── SECTION 1: HERO ───────────────────────────────────── -->
<section class="about-hero"   style="background-image:url('assets/images/banner/custom-about-us.jpg');    background-repeat: no-repeat;background-size: cover;padding-bottom: 40px; height: 100vh;">
    <div class="about-hero__bg-orbs"></div>
    <div class="container-wrapper" style="position:relative;z-index:2;">
<div>
  <span class="about-hero__eyebrow">🏢 Our Story</span>
        <!-- <h1 class="about-hero__h1">We're Building the<br><span>Future of HR.</span></h1> -->
        <h1 class="about-hero__h1">We're Building the<br>Future of HR.</h1>
        <p class="about-hero__p">NeoHRMZ was founded in 2019 with a single mission: help companies put their people first through intelligent automation and a platform that managers actually love.</p>
  <div class="about-hero__actions">
    <a href="careers.html" class="btn btn-white">Join Our Team</a>
          <a href="branding.html" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.4);">View Press Kit</a>
  </div>
</div>
      <div class="about-hero__stat-grid">
        <div class="about-hero__stat-card">
          <div class="about-hero__stat-val">12K+</div>
          <div class="about-hero__stat-lbl">Companies Powered</div>
        </div>
        <div class="about-hero__stat-card">
          <div class="about-hero__stat-val">60+</div>
          <div class="about-hero__stat-lbl">Countries Supported</div>
        </div>
        <div class="about-hero__stat-card">
          <div class="about-hero__stat-val">99.9%</div>
          <div class="about-hero__stat-lbl">Uptime SLA</div>
        </div>
        <div class="about-hero__stat-card">
          <div class="about-hero__stat-val">380+</div>
          <div class="about-hero__stat-lbl">Team Members</div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- ── SECTION 2: MISSION ─────────────────────────────────── -->
  <section class="mission-section">
    <div class="container-wrapper">
      <div class="mission-section__inner">
        <div class="mission-section__visual">
          <div class="mission-quote-card">
            <p class="mission-quote-card__quote">People are not resources to be managed — they are the engine of every great company.</p>
            <div class="mission-quote-card__author">
              <div class="mission-quote-card__avatar">MS</div>
              <div>
                <div class="mission-quote-card__name">Maya Singh</div>
                <div class="mission-quote-card__title">Co-Founder & CEO, NeoHRMZ</div>
              </div>
            </div>
          </div>
          <div class="mission-section__values">
            <div class="mission-section__value-pill">People First</div>
            <div class="mission-section__value-pill">Transparency</div>
            <div class="mission-section__value-pill">Ownership</div>
            <div class="mission-section__value-pill">Inclusivity</div>
            <div class="mission-section__value-pill">Simplicity</div>
            <div class="mission-section__value-pill">Excellence</div>
          </div>
        </div>
        <div class="mission-section__content">
          <p class="mission-section__label">🎯 Our Mission</p>
          <h2 class="mission-section__h2">Transforming How Organizations<br>Care for Their People</h2>
          <p class="mission-section__p">We believe every employee deserves a seamless, dignified experience — from their first offer letter to their last payslip. NeoHRMZ is on a mission to make world-class HR technology accessible to every organization, regardless of size or geography.</p>
          <p class="mission-section__p">Our platform removes the friction from HR workflows so that people teams can spend their time on what actually matters: building a culture where humans thrive.</p>
          <a href="careers.html" class="btn btn-primary" style="margin-top:16px;">Join the Mission</a>
        </div>
      </div>
    </div>
  </section>
  
  <!-- ── SECTION 3: TIMELINE ────────────────────────────────── -->
  <section class="timeline-section">
    <div class="container-wrapper">
      <div class="sec-head">
        <span class="section-eyebrow">📅 Our Journey</span>
        <h2 class="sec-h2">From Idea to<br><span class="gradient-text">12,000+ Customers</span></h2>
      </div>
      <div class="about-timeline">
        <div class="timeline-row">
          <div class="timeline-indicator">2019</div>
          <div class="timeline-body">
            <div class="timeline-year">2019</div>
            <div class="timeline-title">Founded in San Francisco</div>
            <div class="timeline-desc">Three ex-enterprise HR software engineers quit their day jobs and shipped the first version of NeoHRMZ in 48 hours at a Y Combinator hackathon.</div>
          </div>
        </div>
        <div class="timeline-row">
          <div class="timeline-indicator">2020</div>
          <div class="timeline-body">
            <div class="timeline-year">2020</div>
            <div class="timeline-title">Seed Funding & First 500 Customers</div>
            <div class="timeline-desc">Raised $4M seed round, launched our payroll engine in beta, and crossed 500 paying customers — primarily startups and mid-market technology companies.</div>
          </div>
        </div>
        <div class="timeline-row">
          <div class="timeline-indicator">2021</div>
          <div class="timeline-body">
            <div class="timeline-year">2021</div>
            <div class="timeline-title">Series A & International Expansion</div>
            <div class="timeline-desc">After securing a $22M Series A, we opened EU and APAC operations and grew from 200 companies to 2,000 in under 18 months.</div>
          </div>
        </div>
        <div class="timeline-row">
          <div class="timeline-indicator">2023</div>
          <div class="timeline-body">
            <div class="timeline-year">2023</div>
            <div class="timeline-title">Series B & 7,500 Customers</div>
            <div class="timeline-desc">Closed a $68M Series B round led by Sequoia. Launched the enterprise tier, global multi-currency payroll, and HIPAA compliance module for healthcare.</div>
          </div>
        </div>
        <div class="timeline-row">
          <div class="timeline-indicator">2024</div>
          <div class="timeline-body">
            <div class="timeline-year">2024</div>
            <div class="timeline-title">AI Co-Pilot Launch & 12,000 Customers</div>
            <div class="timeline-desc">Launched our AI HR Assistant to universal acclaim in Q2, achieving 80% month-over-month AI feature adoption, and crossed the 12,000 company milestone.</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- ── SECTION 4: TEAM ─────────────────────────────────────── -->
  <section class="team-section">
    <div class="container-wrapper">
      <div class="sec-head">
        <span class="section-eyebrow">👥 Leadership Team</span>
        <h2 class="sec-h2">Built by<br><span class="gradient-text">People People</span></h2>
        <p class="sec-sub">Our leadership team brings decades of combined experience in HR software, compliance law, and enterprise engineering.</p>
      </div>
      <div class="team-grid">
        <div class="team-member-card">
          <div class="team-avatar">JD</div>
          <div class="team-name">Joshna Devadanam</div>
          <div class="team-role">Co-Founder & CEO</div>
          <span class="team-dept">Leadership</span>
        </div>
        <div class="team-member-card">
          <div class="team-avatar">SB</div>
          <div class="team-name">Santhosh B</div>
          <div class="team-role">Co-Founder & CTO</div>
          <span class="team-dept">Engineering</span>
        </div>
        <div class="team-member-card">
          <div class="team-avatar">JC</div>
          <div class="team-name">Joel Charan</div>
          <div class="team-role">VP of Product</div>
          <span class="team-dept">Product</span>
        </div>
        <div class="team-member-card">
          <div class="team-avatar">SP</div>
          <div class="team-name">Sunny Pesala</div>
          <div class="team-role">Head of HR & Culture</div>
          <span class="team-dept">People</span>
        </div>
      </div>
    </div>
  </section>
  
  <!-- ── SECTION 5: VALUES ───────────────────────────────────── -->
  <section class="values-section">
    <div class="container-wrapper">
      <div class="sec-head">
        <span class="section-eyebrow">✦ What We Stand For</span>
        <h2 class="sec-h2">Our Core <span class="gradient-text">Values</span></h2>
        <p class="sec-sub">Everything we build reflects a deep commitment to these principles — in our product, our culture, and our community.</p>
      </div>
      <div class="values-section__grid">
        <div class="value-card">
          <div class="value-card__icon">❤️</div>
          <div class="value-card__title">People First, Always</div>
          <div class="value-card__desc">Every feature we ship starts with a single question: does this make life easier for the HR professional or the employee? We never sacrifice human experience for technical elegance.</div>
        </div>
        <div class="value-card">
          <div class="value-card__icon">🔒</div>
          <div class="value-card__title">Radical Transparency</div>
          <div class="value-card__desc">We publish our uptime metrics, release notes, and incident reports publicly. We believe trust is built through openness — not through polished PR responses.</div>
        </div>
        <div class="value-card">
          <div class="value-card__icon">⚡</div>
          <div class="value-card__title">Speed with Purpose</div>
          <div class="value-card__desc">We move fast, but never recklessly. Every deployment is tested, every data point validated. We know that HR data is sensitive — and we treat it that way.</div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- ── SECTION 6: CTA ──────────────────────────────────────── -->
  <section class="about-cta">
    <div class="container-wrapper">
      <h2 class="about-cta__h2">Want to Build the Future<br><div class="mt-4">of HR With Us?</div></h2>
      <p class="about-cta__p">We're hiring across engineering, product, design, compliance, and customer success. Fully remote, globally distributed.</p>
      <div class="about-cta__actions">
        <a href="careers.html" class="btn btn-white">View Open Positions</a>
        <a href="contact.html" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.4);">Contact Our Team</a>
      </div>
    </div>
  </section>
  <app-peopleflow-footer></app-peopleflow-footer>
